import { render, staticRenderFns } from "./MiniTCDCTable.vue?vue&type=template&id=d3285c5c&scoped=true&"
import script from "./MiniTCDCTable.vue?vue&type=script&lang=js&"
export * from "./MiniTCDCTable.vue?vue&type=script&lang=js&"
import style0 from "./MiniTCDCTable.vue?vue&type=style&index=0&id=d3285c5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3285c5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VSimpleTable,VSpacer,VSystemBar})
